module.exports = __webpack_public_path__ + "static/media/zolePlayed_50000_100000.bd7786cf.png";